import { useLocationStore } from '@global-store/stores/location'
import { addDaysAndExcludeSundays } from '@shared/fondof-fn/date/add'

const defaultFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
}

export const formatDate = (
  date: number | Date,
  formatOptions: object = defaultFormatOptions
) => {
  const locationStore = useLocationStore()

  return new Date(date).toLocaleDateString(
    locationStore.currentLocale,
    formatOptions
  )
}

export const formatDateRange = (days: string) => {
  const daysArr = days.substring(0, days.lastIndexOf(' ')).split('-')
  const now = new Date()

  const dateRange = daysArr.map((day: string) => {
    const daysFromNow = parseInt(day)

    const datePoint = formatDate(addDaysAndExcludeSundays(now, daysFromNow), {
      weekday: 'short',
      month: 'numeric',
      day: 'numeric',
    }).replace(',', '')

    return datePoint
  })

  // U+2013 "–" (en dash) is used here by intend, because it's the correct typographic symbol for date ranges
  return dateRange.length > 1
    ? `${dateRange[0]} – ${dateRange[1]}`
    : dateRange[0]
}
